import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { checkErrors } from "../../../jsx/global-functions/checkErrors";

export const changeAdminPassFunc = createAsyncThunk("change admin pass function", async ({ api, data }) => {
  const token = window.localStorage.getItem("token");
  const config = {
    headers: {
      Authorization: `Bearer ${token}`, // Include the token in the Authorization header
    },
  };
  try {
    // change method nnn
    const response = await axios.post(api, data, config);
    // const response = await axios.put(api , data , config);
    return response.data;
  } catch (error) {
    checkErrors(error.response, error.message);
  }
});

const changeAdminPassSlicer = createSlice({
  name: "change admin pass slicer",
  initialState: {
    loading: null,
    data: null,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(changeAdminPassFunc.pending, (state) => {
      state.loading = true;
      state.data = {};
      state.error = false;
    });
    builder.addCase(changeAdminPassFunc.rejected, (state) => {
      state.loading = false;
      state.data = {};
      state.error = true;
    });
    builder.addCase(changeAdminPassFunc.fulfilled, (state, action) => {
      state.loading = false;
      state.data = action.payload;
      state.error = false;
    });
  },
});

export default changeAdminPassSlicer.reducer;
